module.exports = ".btn {\n  float: right; }\n\n.little-loader {\n  float: right; }\n\ninput.text {\n  max-width: calc(100% - 10px);\n  min-width: calc(100% - 10px); }\n\n@media only screen and (max-width: 599px) {\n  .btn {\n    float: none;\n    margin-top: 10px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/search-box/search-box.component.scss
// module id = 683
// module chunks = 0